import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-api-status-details',
  template: `
    @if (data) {
      <div class="details">
        <div class="text-center p-4">
          @if (data.status === 'Healthy') {
            <img src="assets/images/JMicons/JM-icon-17.png" alt="icon">
          }
          @if (data.status !== 'Healthy') {
            <img src="assets/images/JMicons/JM-icon-18.png" alt="icon">
          }
        </div>
        <h3 class="text-center">{{ data.name }}</h3>
        <table class="table table-bordered m-0">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Healthy</th>
            </tr>
          </thead>
          <tbody>
            @for (service of data.details.checks; track service) {
              <tr>
                <td>{{ service.name }}</td>
                <td>{{ service.isHealthy }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }`,
  standalone: false
})
export class ApiStatusDetailComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}
